/**
 * Venttra - Admin Division Types collection
 * Types for administrative divisions (Canton, State, Region, etc.) with localized names.
 * Used as dropdown on administrative_division destinations. Types are translated once per code.
 */
import { buildCollection } from "@firecms/core";
import { editorOrAdminPermissions } from "../permissions";
import { CONTENT_LOCALES, LOCALE_LABELS } from "../constants";

export const adminDivisionTypesCollection = buildCollection({
  id: "admin_division_types",
  name: "Admin Division Types",
  singularName: "Admin Division Type",
  path: "admin_division_types",
  icon: "Category",
  group: "Content",
  permissions: editorOrAdminPermissions,
  properties: {
    code: {
      name: "Code",
      dataType: "string",
      description:
        "Unique identifier (e.g. canton, state, region, island). Must be unique — run Dedupe admin division types in Data Tools if duplicates appear.",
      validation: { required: true },
    },
    name_localized: {
      name: "Name (localized)",
      dataType: "map",
      description: "Type name in en, de, fr, it (e.g. Canton, Kanton, Canton, Cantone)",
      properties: Object.fromEntries(
        CONTENT_LOCALES.map((locale) => [
          locale,
          { name: LOCALE_LABELS[locale], dataType: "string" as const },
        ])
      ),
    },
  },
});
